import React from "react";
import {ScatterChartPro} from "@mui/x-charts-pro";
import CCMuiChart from "./CCMuiChart";

class CCScatterChart extends CCMuiChart {
    static ATTR_MAP: [string, string][] = [
        ["AxisHighlight", "axisHighlight"],
        ["BrushConfig", "brushConfig"],
        ["Colors", "colors"],
        ["Dataset", "dataset"],
        ["DisableAxisListener", "disableAxisListener"],
        ["Grid", "grid"],
        ["Height", "height"],
        ["HiddenItems", "hiddenItems"],
        ["HideLegend", "hideLegend"],
        ["HighlightedAxis", "highlightedAxis"],
        ["HighlightedItem", "highlightedItem"],
        ["Id", "id"],
        ["LoadingText", "loadingText"],
        ["Margin", "margin"],
        ["onAxisClick", "onAxisClick"],
        ["onHiddenItemsChange", "onHiddenItemsChange"],
        ["onHighlightChange", "onHighlightChange"],
        ["onHighlightedAxisChange", "onHighlightedAxisChange"],
        ["onItemClick", "onItemClick"],
        ["onZoomChange", "onZoomChange"],
        ["ShowToolbar", "showToolbar"],
        ["SkipAnimation", "skipAnimation"],
        ["SlotProps", "slotProps"],
        ["Slots", "slots"],
        ["VoronoiMaxRadius", "voronoiMaxRadius"],
        ["Width", "width"],
        ["ZoomData", "zoomData"],
        ["ZoomInteractionConfig", "zoomInteractionConfig"],
    ];

    renderChart(chartProps: any): React.ReactNode {
        return <ScatterChartPro {...chartProps} sx={this.props.sx} />;
    }
}

export default CCScatterChart;
